import type { TeamsUserCredentialAuthConfig } from '@microsoft/teamsfx'
import { LogLevel, setLogLevel, setLogFunction, TeamsUserCredential } from '@microsoft/teamsfx'
import { useData } from './useData'

export type TeamsContextWithCredential = {
  teamsUserCredential?: TeamsUserCredential
  loading: boolean
  error: unknown
  inTeams?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context?: any
}

/**
 * Initialize TeamsFx SDK with customized configuration.
 *
 * @param authConfig - custom configuration to override default ones.
 * @returns TeamsContextWithCredential object
 *
 * @public
 */
export function useTeamsUserCredential(authConfig: TeamsUserCredentialAuthConfig): TeamsContextWithCredential {
  const { data, error, loading } = useData(() => {
    if (process.env.NODE_ENV === 'development') {
      setLogLevel(LogLevel.Verbose)
      setLogFunction((level: LogLevel, message: string) => {
        console.log(message)
      })
    }
    return Promise.resolve(new TeamsUserCredential(authConfig))
  })
  return {
    teamsUserCredential: data,
    error,
    loading: loading,
  }
}
